import React from 'react';
import classnames from 'classnames';
import {connect} from 'react-redux';
import * as PropTypes from 'prop-types';
import EmployeeLoginFlow from '../components/employee-login/index.jsx';
import {useIntl} from 'react-intl';
import {getMessages} from '../i18n/messageUtil';

/**
 * Common container for the neuro-app to provide a consistent structure for
 * classnames based on the state of the app. Also requires the consumer to use an
 * ErrorBoundary
 */
const AppContainer = ({children, className, ErrorBoundary, location, loginFlowEnabled, page, processingNavigation}) => {
  const intl = useIntl();

  const getAppPageTypeModifier = () => {
    let result = '';
    const pathname = location.pathname;
    if (pathname === '/guide') {
      result = 'app--landingPage';
    } else if (pathname.includes('spa')) {
      result = 'app--surveyPage';
    } else if (pathname.includes('summary')) {
      result = 'app--summaryPage';
    } else if (pathname.includes('details')) {
      result = 'app--detailsPage';
    }
    return result;
  };

  const pathName = page.path ? page.path.key : '';
  const pageName = page.page ? page.page.key : '';
  const appClasses = classnames('app', getAppPageTypeModifier(location.pathname), className, {
    [`app--path-${pathName}`]: pathName,
    [`app--page-${pageName}`]: pageName,
    ['app--processing']: processingNavigation,
  });

  return (
    <div className={appClasses}>
      <ErrorBoundary>
        {loginFlowEnabled ? <EmployeeLoginFlow messages={getMessages(intl.locale)} /> : null}
        {children}
      </ErrorBoundary>
    </div>
  );
};

AppContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  ErrorBoundary: PropTypes.elementType.isRequired,
  loginFlowEnabled: PropTypes.bool,
  location: PropTypes.object.isRequired,
  page: PropTypes.object,
  processingNavigation: PropTypes.any,
};

export default connect((state, {location}) => {
  const page = state.pages[location.pathname] || {};
  const processingNavigation = state.processingNavigation || false;
  const employeeLoginState = state.employeeLoginState || {};

  return {
    location,
    loginFlowEnabled: employeeLoginState.loginFlowEnabled,
    processingNavigation,
    page,
  };
})(AppContainer);
